import './loading.css'; 
import { FaSpinner } from "react-icons/fa6";

const LoadingIcon = () => {
    return(
        <FaSpinner size="20" className="loading-icon"/>
    )
}

export default LoadingIcon